import React from 'react';
import Form from '../../../components/common/Form';
import {Line} from 'react-chartjs-2';
import {labels, optionsTimeSpan} from "../../constants/constants";
import Loader from '../../utils/loader'
import {getCurrentUserId} from "../../../services/authService";
// import ReactGA from "react-ga";
import ChartLoader from "../../utils/chart-loader";

class SubscribersHistory extends Form {
    constructor(props) {
        super(props);
        this.state = {
            fb_acquisitions_by_month: this.props.fb_acquisitions_by_month,
            fb_subscribers_by_month: this.props.fb_subscribers_by_month,

            webpush_related_data_by_month: this.props.webpush_related_data_by_month,
            webpush_acquisitions_by_month: this.props.webpush_acquisitions_by_month,

            subscribers_count_total: this.props.subscribers_count_total,
            subscribers_count_fb_month: this.props.subscribers_count_fb_month,

            subscribers_count_wp_total: this.props.subscribers_count_wp_total,
            subscribers_count_wp_total_all: this.props.subscribers_count_wp_total_all,

            subscribers_count_total_up: this.props.subscribers_count_total_up,
            subscribers_count_total_down: this.props.subscribers_count_total_down,
            subscribers_count_total_up_month: this.props.subscribers_count_total_up_month,
            subscribers_count_total_down_month: this.props.subscribers_count_total_down_month,
            labels_from_response: this.props.labels_from_response,
            errors: {},
            timeSpan: 'Last ' + this.props.time_span + ' days',
            labels_to_use: this.props.labels_from_response,
        };
    }

    componentDidUpdate = () => {
        if (this.state.subscribers_count_total !== this.props.subscribers_count_total) {
            this.setState({
                subscribers_count_total: this.props.subscribers_count_total
            });
        }

        if (this.state.subscribers_count_wp_total_all !== this.props.subscribers_count_wp_total_all) {
            this.setState({
                subscribers_count_wp_total_all: this.props.subscribers_count_wp_total_all
            });
        }

        if (this.state.subscribers_count_fb_month !== this.props.subscribers_count_fb_month) {
            this.setState({
                subscribers_count_fb_month: this.props.subscribers_count_fb_month
            });
        }

        if (this.state.webpush_related_data_by_month !== this.props.webpush_related_data_by_month) {
            this.setState({
                webpush_related_data_by_month: this.props.webpush_related_data_by_month
            });
        }

        if (this.state.webpush_acquisitions_by_month !== this.props.webpush_acquisitions_by_month) {
            this.setState({
                webpush_acquisitions_by_month: this.props.webpush_acquisitions_by_month
            });
        }

        if (this.state.subscribers_count_wp_total !== this.props.subscribers_count_wp_total) {
            this.setState({
                subscribers_count_wp_total: this.props.subscribers_count_wp_total
            });
        }

        if (this.state.subscribers_count_total_up !== this.props.subscribers_count_total_up) {
            this.setState({
                subscribers_count_total_up: this.props.subscribers_count_total_up
            });
        }

        if (this.state.subscribers_count_total_up_month !== this.props.subscribers_count_total_up_month) {
            this.setState({
                subscribers_count_total_up_month: this.props.subscribers_count_total_up_month
            });
        }

        if (this.state.subscribers_count_total_down_month !== this.props.subscribers_count_total_down_month) {
            this.setState({
                subscribers_count_total_down_month: this.props.subscribers_count_total_down_month
            });
        }

        if (this.state.subscribers_count_total_down !== this.props.subscribers_count_total_down) {
            this.setState({
                subscribers_count_total_down: this.props.subscribers_count_total_down
            });
        }

        if (this.state.fb_acquisitions_by_month !== this.props.fb_acquisitions_by_month) {
            this.setState({
                fb_acquisitions_by_month: this.props.fb_acquisitions_by_month
            });
        }

        if (this.state.fb_subscribers_by_month !== this.props.fb_subscribers_by_month) {
            this.setState({
                fb_subscribers_by_month: this.props.fb_subscribers_by_month
            });
        }

        if (this.state.labels_from_response !== this.props.labels_from_response) {
            this.setState({
                labels_from_response: this.props.labels_from_response,
                labels_to_use: this.props.labels_from_response
            });
        }
        if (!this.state.timeSpan.includes(this.props.time_span)) {

            this.setState({timeSpan: 'Last '+ this.props.time_span + ' days'});
        }

    }

    handleChangeSelectSearch = (selectedParam) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Dashboard Subscribers History - Change days',
        //     userId: getCurrentUserId(),
        //     label: selectedParam.target,
        //     nonInteraction: true
        // });

        const target = selectedParam.target;
        const value = target.textContent;
        let labels_to_use = this.state.labels_from_response;
        if (value.toString() !== "Last year") {
            labels_to_use = labels
        }
        this.setState({
            timeSpan: value,
            labels_to_use: labels_to_use
        });
        this.props.getSpanData(value);
    };

    render() {
        const {
            fb_subscribers_by_month,
            fb_acquisitions_by_month,
            webpush_related_data_by_month,
            webpush_acquisitions_by_month,
            subscribers_count_total,
            subscribers_count_fb_month,
            subscribers_count_wp_total,
            subscribers_count_wp_total_all,
            subscribers_count_total_up,
            subscribers_count_total_down,
            subscribers_count_total_up_month,
            subscribers_count_total_down_month,
            labels_to_use
        } = this.state;

        let subscribers_count_fb = {
            label: 'Facebook Messenger',
            data: subscribers_count_fb_month,
            tension: 0,
            backgroundColor: [
                '#4278BE'
            ],
            fill: false,
            borderColor: [
                '#4278BE'
            ],
            borderWidth: 1,

            pointRadius: 4,
            pointBorderColor: 'rgba(66,120,190,0.2)',
            pointBorderWidth: '10',
            pointBackgroundColor: '#4278BE'
        };

        const datasetsSubscribersHistory = [subscribers_count_fb,
            {
                label: 'Web Push',
                data: subscribers_count_wp_total,

                tension: 0,

                backgroundColor: [
                    '#17AA94'
                ],
                fill: false,
                borderColor: [
                    '#17AA94'
                ],
                borderWidth: 1,

                pointRadius: 4,
                pointBorderColor: 'rgba(23,170,148,0.2)',
                pointBorderWidth: '10',
                pointBackgroundColor: '#17AA94',
                hidden: subscribers_count_wp_total_all ? false : true
            }
            //,
            //{
            //    label: 'Slack',
            //    data: subscribers_count_slack_total,
            //    tension: 0,
            //
            //    backgroundColor: [
            //        'transparent'
            //
            //    ],
            //    borderColor: [
            //        '#543651'
            //    ],
            //    borderWidth: 1,
            //
            //    pointRadius: 4,
            //    pointBorderColor: 'rgba(84,54,81,0.2)',
            //    pointBorderWidth: '10',
            //    pointBackgroundColor: '#543651'
            //},
            //{
            //    label: 'Twitter',
            //    data: [],
            //    tension: 0,
            //
            //    backgroundColor: [
            //        'transparent'
            //
            //    ],
            //    borderColor: [
            //        '#049FF6'
            //    ],
            //    borderWidth: 1,
            //
            //    pointRadius: 4,
            //    pointBorderColor: 'rgba(4,159,246,0.2)',
            //    pointBorderWidth: '10',
            //    pointBackgroundColor: '#049FF6'
            //},
            //{
            //    label: 'LinkedIn',
            //    data: [],
            //    tension: 0,
            //
            //    backgroundColor: [
            //        'transparent'
            //
            //    ],
            //    borderColor: [
            //        '#0076B7'
            //    ],
            //    borderWidth: 1,
            //    pointRadius: 4,
            //    pointBorderColor: 'rgba(0,118,183,0.2)',
            //    pointBorderWidth: '10',
            //    pointBackgroundColor: '#0076B7'
            //}
        ];
        let dataSubscribersHistory = {
            labels: labels_to_use,
            datasets: datasetsSubscribersHistory
        };
        let optionsSubscribersHistory = {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            legend: {
                labels: {
                    usePointStyle: true
                }
            },
            tooltips: {

                // Disable the on-canvas tooltip
                enabled: false,

                custom: function (tooltipModel) {
                    // Tooltip Element
                    var tooltipEl = document.getElementById('history-tooltip');

                    // Create element on first render
                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.id = 'history-tooltip';
                        tooltipEl.innerHTML = "<tooltip></tooltip>";
                        document.body.appendChild(tooltipEl);
                    }

                    // Hide if no tooltip
                    if (tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    // Set caret Position
                    tooltipEl.classList.remove('above', 'below', 'no-transform');
                    if (tooltipModel.yAlign) {
                        tooltipEl.classList.add(tooltipModel.yAlign);
                    } else {
                        tooltipEl.classList.add('no-transform');
                    }

                    function getBody(bodyItem) {
                        return bodyItem.lines;
                    }

                    // Set Text
                    if (tooltipModel.body) {
                        var titleLines = tooltipModel.title || [];
                        var bodyLines = tooltipModel.body.map(getBody);
                        var innerHtml = '';
                        titleLines.forEach(function (title) {
                            innerHtml += '<table class="tooltip-table-title tooltip-table m-m-b">' +
                                '    <thead>' +
                                '    <tr>' +
                                '       <th>' + title + '</th>' +
                                '       <th>' + subscribers_count_total[title] + '</th> ' +
                                '    </tr> ' +
                                '    </thead> ' +
                                '</table> ' +
                                '\n' +
                                '\n' +
                                fb_subscribers_by_month[title] +
                                webpush_related_data_by_month[title] +
                                '\n' +
                                '\n';
                        });
                        innerHtml += '';

                        bodyLines.forEach(function (body, i) {

                            innerHtml += '';

                        });

                        var tableRoot = tooltipEl.querySelector('tooltip');
                        tableRoot.innerHTML = innerHtml;
                    }

                    // `this` will be the overall tooltip
                    var position = this._chart.canvas.getBoundingClientRect();

                    // Display, position, and set styles for font
                    tooltipEl.style.opacity = 1;
                    tooltipEl.style.position = 'fixed';
                    tooltipEl.style.left = position.left + tooltipModel.caretX + 'px';
                    tooltipEl.style.top = position.top + tooltipModel.caretY + 'px';
                    tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                    tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                    tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                    tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                    tooltipEl.style.backgroundColor = "rgba(52, 74, 94, 0.9)";
                    tooltipEl.style.color = "#fff";
                    tooltipEl.style.borderRadius = '4px';
                    tooltipEl.style.padding = '20px';
                }
            }
        };

        const datasetsSubscribersAcquisitionHistory = [
            {

                label: 'New Subscribers',
                data: subscribers_count_total_up,
                tension: 0,
                backgroundColor: [
                    '#0BB158'
                ],
                fill: false,
                borderColor: [
                    '#0BB158'
                ],
                borderWidth: 1,

                pointRadius: 4,
                pointBorderColor: 'rgba(11,177,88,0.2)',
                pointBorderWidth: '10',
                pointBackgroundColor: '#0BB158'
            },
            {
                label: 'Unsubscribed',
                data: subscribers_count_total_down,

                tension: 0,

                backgroundColor: [
                    '#EF4848'
                ],
                fill: false,
                borderColor: [
                    '#EF4848'
                ],
                borderWidth: 1,

                pointRadius: 4,
                pointBorderColor: 'rgba(239,72,72,0.2)',
                pointBorderWidth: '10',
                pointBackgroundColor: '#EF4848'
            }

        ];

        let dataSubscribersAcquisitionHistory = {
            labels: labels_to_use,
            datasets: datasetsSubscribersAcquisitionHistory
        };

        let optionsAcquisitionHistory = {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            legend: {
                labels: {
                    usePointStyle: true
                }
            },
            tooltips: {

                // Disable the on-canvas tooltip
                enabled: false,

                custom: function (tooltipModel) {
                    //console.log("tooltipModel", tooltipModel);
                    // Tooltip Element
                    var tooltipEl = document.getElementById('acquisition-tooltip');

                    // Create element on first render
                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.id = 'acquisition-tooltip';
                        tooltipEl.innerHTML = "<tooltip></tooltip>";
                        document.body.appendChild(tooltipEl);
                    }

                    // Hide if no tooltip
                    if (tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = 0;
                        return;
                    }

                    // Set caret Position
                    tooltipEl.classList.remove('above', 'below', 'no-transform');
                    if (tooltipModel.yAlign) {
                        tooltipEl.classList.add(tooltipModel.yAlign);
                    } else {
                        tooltipEl.classList.add('no-transform');
                    }

                    function getBody(bodyItem) {
                        return bodyItem.lines;
                    }

                    // Set Text
                    if (tooltipModel.body) {
                        var titleLines = tooltipModel.title || [];
                        var bodyLines = tooltipModel.body.map(getBody);

                        var innerHtml = '';
                        //console.log("titleLines", titleLines);
                        titleLines.forEach(function (title) {
                            //console.log("slack_acquisitions_by_month[title]", slack_acquisitions_by_month[title]);
                            innerHtml += '<table class="tooltip-table-title tooltip-table m-m-b">' +
                                '    <thead>' +
                                '    <tr>' +
                                '       <th>' + title + '</th>' +
                                '       <th><span class="fas fa-caret-up"></span>' + subscribers_count_total_up_month[title] + '</th>' +
                                '       <th><span class="fas fa-caret-down"></span>' + subscribers_count_total_down_month[title] + '</th> ' +
                                '    </tr> ' +
                                '    </thead> ' +
                                '</table> ' +
                                '\n' +
                                '\n' +
                                fb_acquisitions_by_month[title] +
                                webpush_acquisitions_by_month[title] +
                                '\n' +
                                '\n';

                        });

                        innerHtml += '';

                        bodyLines.forEach(function (body, i) {

                            innerHtml += '';

                        });

                        var tableRoot = tooltipEl.querySelector('tooltip');
                        tableRoot.innerHTML = innerHtml;
                    }

                    // `this` will be the overall tooltip
                    var position = this._chart.canvas.getBoundingClientRect();

                    // Display, position, and set styles for font
                    tooltipEl.style.opacity = 1;
                    tooltipEl.style.position = 'fixed';
                    tooltipEl.style.left = position.left + tooltipModel.caretX + 'px';
                    tooltipEl.style.top = position.top + tooltipModel.caretY + 'px';
                    tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                    tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                    tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                    tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                    tooltipEl.style.backgroundColor = "rgba(52, 74, 94, 0.9)";
                    tooltipEl.style.color = "#fff";
                    tooltipEl.style.borderRadius = '4px';
                    tooltipEl.style.padding = '20px';
                }
            }
        };
        //console.log("optionsAcquisitionHistory", optionsAcquisitionHistory.legend.labels.borderRadius);
        return (
            <div className="col-xl-9">
                <div className="row">
                    <div className="col-xs-4">
                        <p className="m-m-b">Subscribers History</p>
                    </div>
                    <div className="col-xs-8 select-holder">
                        <div className="nice-select" tabIndex="0">
                            <span className="current">{this.state.timeSpan}</span>
                            <ul className="list">
                                {
                                    optionsTimeSpan.map(option => (
                                        <li key={option.value}

                                            id={option.value}
                                            onClick={this.handleChangeSelectSearch}
                                            className={(option.text === this.state.timeSpan) ? "option active selected" : "option"}>
                                            {option.text}
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                </div>
                <img className="chart-blur" src="/img/chart-2-rotate.png" alt="Rotate For Chart 2"/>
                {this.props.loadingSource ?
                    <ChartLoader/>
                    :
                    (this.props.loader ?
                            <ChartLoader/>
                            :
                            <Line data={dataSubscribersHistory} options={optionsSubscribersHistory}/>
                    )
                }

                <div className="row" style={{marginTop: "30px"}}>
                    <div className="col-xs-6">
                        <p className="m-m-b">Subscribers Acquisition History</p>
                    </div>
                    <div className="col-xs-8">

                    </div>
                </div>

                <img className="chart-blur" src="/img/chart-3-rotate.png" alt="Rotate For Chart 3"/>
                {this.props.loadingSource ?
                    <ChartLoader/> :

                    (this.props.loader ?
                            <ChartLoader/>

                            :
                            <Line data={dataSubscribersAcquisitionHistory} options={optionsAcquisitionHistory}/>
                    )
                }
            </div>
        )
    }
}

export default SubscribersHistory

/*
 {
 label: 'Twitter',
 data: [30, 70, 60, 110, 115, 130, 140, 120, 150, 70, 100, 130],
 tension: 0,

 backgroundColor: [
 'transparent'

 ],
 borderColor: [
 '#049FF6'
 ],
 borderWidth: 1,

 pointRadius: 4,
 pointBorderColor: 'rgba(4,159,246,0.2)',
 pointBorderWidth: '10',
 pointBackgroundColor: '#049FF6'
 },
 {
 label: 'LinkedIn',
 data: [60, 50, 60, 110, 60, 30, 60, 30, 90, 100, 120, 110],
 tension: 0,

 backgroundColor: [
 'transparent'

 ],
 borderColor: [
 '#0076B7'
 ],
 borderWidth: 1,
 pointRadius: 4,
 pointBorderColor: 'rgba(0,118,183,0.2)',
 pointBorderWidth: '10',
 pointBackgroundColor: '#0076B7'
 }
 * */